// extracted by mini-css-extract-plugin
export var container = "tasksList-module--container--b454a";
export var content = "tasksList-module--content--2b406";
export var dismissButton = "tasksList-module--dismissButton--b3662";
export var flexContainer = "tasksList-module--flexContainer--c17b2";
export var header = "tasksList-module--header--3176b";
export var itemTasksContainer = "tasksList-module--itemTasksContainer--ffebd";
export var list = "tasksList-module--list--f5a12";
export var pagingButtons = "tasksList-module--pagingButtons--737eb";
export var removeScroll = "tasksList-module--removeScroll--3a5d3";